<template>
    <div class="map-page">
        <div class="content">
            <!-- Map -->
            <div class="map-container column-map left-pos-map">
                <div id="map-main"></div>
                <div class="scrollContorl maplocbtn" @click="panToUserLocation()" title="Get Location"><span><i class="fa fa-compass"></i></span></div>
                <ul class="mapnavigation">
                    <li><a href="#" class="direciton-click prevmap-nav" @click="directionClick($event, 'prev')">Prev</a></li>
                    <li><a href="#" class="direciton-click nextmap-nav" @click="directionClick($event, 'next')">Next</a></li>
                </ul>
                <div class="scrollContorl mapnavbtn" title="Enable Scrolling"><span><i class="fa fa-lock"></i></span></div>
            </div>
            <!-- Map end -->
            <!--col-list-wrap -->
            <div class="col-list-wrap right-list" ref="mainWrapperRef">
                <!-- list-main-wrap-->
                <div class="list-main-wrap fl-wrap card-listing">
                    <a class="custom-scroll-link back-to-filters btf-r" href="#lisfw"><i class="fa fa-angle-double-up"></i><span>Back to Filters</span></a>
                    <div class="container">
                        <!--@foreach($store as $new_store)-->
                        <!-- listing-item -->

                        <template v-for="store in stores">
                            <div v-if="store.in_view === true" class="listing-item">
                                <article class="geodir-category-listing fl-wrap">
                                    <div v-if="store.photos.length > 50" class="fw-map-carousel fl-wrap full-height lightgallery">
                                        <div class="slick-slide-item" v-for="photo in store.photos">
                                            <div class="box-item">
                                                <img :src="photo.path"   alt="">
                                                <a :href="photo.path" class="gal-link popup-image"><i class="fa fa-search"  ></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="geodir-category-img" :style="'background: url( '+store.main_img+') center no-repeat'">
                                        <div class="overlay"></div>
                                        <div class="list-post-counter"><span>4</span><i class="fa fa-heart"></i></div>
                                    </div>
                                    <div class="geodir-category-content fl-wrap">
                                        <a class="listing-geodir-category" :href="store.store_url_slug">{{ store.store_type }}</a>
                                        <h3><a :href="store.store_url_slug">{{ store.store_name }}</a></h3>
                                        <p>Sed interdum metus at nisi tempor laoreet. Integer gravida orci a justo sodales, sed lobortis est placerat.</p>
                                        <div class="geodir-category-options fl-wrap">
                                            <div class="listing-rating card-popup-rainingvis" :data-starrating2="store.google_rating"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>
                                                <span>({{ store.google_rating_count }} google reviews)</span>
                                            </div>
                                            <div class="geodir-category-location"><a href="#0" class="map-item"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ store.store_address }}</a></div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </template>
                        <!-- listing-item end-->
                        <!--@endforeach-->
                    </div>
                </div>
                <!-- list-main-wrap end-->
            </div>
            <!--col-list-wrap end -->
            <div class="limit-box fl-wrap"></div>
        </div>
        <!--content end -->
        <div class="limit-box fl-wrap"></div>
        <div class="map-popup-reference" v-if="activeStore" v-show="false" ref='popupContainer'>
            <div class="map-popup-wrap">
                <div class="map-popup">
                    <div class="infoBox-close" @click="popupClose()">
                        <i class="fa fa-times"></i>
                    </div>
                    <div class="map-popup-category">{{ activeStore.store_type }}</div>
                    <div class="listing-img-content fl-wrap">
                        <div id="map-inner-carousel" ref="popupSlider" class="fw-map-carousel splide fl-wrap full-height lightgallery">
                            <div class="splide__track">
                                <ul class="splide__list"><li v-for="photo in activeStore.photos" class="splide__slide"><img :src="photo" /></li></ul>
                            </div>
                        </div>
                    </div>
                    <div class="listing-content fl-wrap">
                        <div class="card-popup-raining map-card-rainting" data-staRrating="">
                            <span class="map-popup-reviews-count">( {{ activeStore.ratingCount == 1 ? activeStore.ratingCount + ' review' : activeStore.ratingCount + ' reviews' }} )</span>
                        </div>
                        <div class="listing-title fl-wrap">
                            <h4><a :href="'/'+activeStore.store_url_slug">{{ activeStore.store_name }}</a></h4>
                            <span class="map-popup-location-info"><i class="fa fa-map-marker"></i>{{ activeStore.store_address }}</span>
                            <span class="map-popup-location-phone"><i class="fa fa-phone"></i>{{ activeStore.store_phone }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['initialStores'],

    data: function() {
        return {
            isActive: undefined,
            storemap: '',
            markers: '',
            marker: [],
            loadedIds: [],
            activeStore: '',
            stores: {},
            markersArray: [],
            zoomCoords: {},
            zoomLevel: '',
            sideHeight: '',
            tiles: '',
            userLocation: null,
            gettingLocation: false,
            errorStr: null,
            dates: new Date(),
            dayText: '',
            splide_slider: '',
            winWidth: $(window).width(),
            popupSliderFirstRun: false,
        }

    },

    created: function(){
        let _this = this;
        /*Object.keys(this.initialStores).forEach(function (index, value) {
            _this.stores.push(_this.initialStores[index]);
        });*/
        if(!("geolocation" in navigator)) {
            this.errorStr = 'Geolocation is not available.';
            return;
        }
        _this.getUserLocation();
        document.addEventListener("resize", this.getWindowWidth);

    },
    destroyed() {
        document.removeEventListener("resize", this.getWindowWidth);
    },
    mounted() {
        let _this = this;
        this.mainMap();
        //$('.sidebar-listing').height($('.sidebar-listing').outerHeight());
        //this.initSidebar();
        window.onresize = () => {
            this.getWindowWidth();
        }


    },
    computed: {
    },

    methods: {
        mainMap() {
            this.storemap = L.map('map-main');

            this.storemap.on('load', function(){
                setTimeout(() => {
                    this.invalidateSize(true);
                }, 800);
            });

            this.storemap.setView([45.4215, -75.6972], 12);
            this.tiles = L.tileLayer('//stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.storemap);

            this.loadMarkers();
            //this.getVisibleMarkers();
            //this.storemap.on('zoomend moveend', this.getVisibleMarkers);
            this.storemap.on('zoomend', this.getVisibleMarkers);
        },
        getWindowWidth(e) {
            this.winWidth = document.documentElement.clientWidth;
        },
        panToUserLocation() {
            this.storemap.panTo([this.userLocation.coords.latitude, this.userLocation.coords.longitude]);
        },
        getUserLocation() {
            this.gettingLocation = true;
            // get position
            navigator.geolocation.getCurrentPosition(pos => {
                this.gettingLocation = false;
                this.userLocation = pos;
                this.panToUserLocation();
            }, err => {
                this.gettingLocation = false;
                this.errorStr = err.message;
            })
        },
        getSingleStore(store_id) {
            let _this = this;
            return axios.post('/api/singlestore/', {store_id: store_id})
                .then(response => {
                    _this.activeStore = response.data;
                })
                .catch(error => {
                    console.log(error)
                });
        },
        loadMarkers() {
            this.markers = L.markerClusterGroup({ chunkedLoading: true });
            for (var i = 0; i < this.initialStores.length; i++) {

                this.marker[i] = L.marker(L.latLng(this.initialStores[i].lat, this.initialStores[i].lng), {store_id: this.initialStores[i].id, loop_id: i}).on('click', this.markerClicked);

                //this.markers.addLayer(this.marker[i]);
                if(this.loadedIds.indexOf(this.initialStores[i].id) === -1) {
                    this.loadedIds.push(this.initialStores[i].id);
                }
            }

            this.markers.addLayers(this.marker);
            this.storemap.addLayer(this.markers);

        },
        popupClose() {
            this.storemap.closePopup();
        },
        getVisibleMarkers() {
            this.updateZoom();
            let _this = this;
            let current_marker = {};
            let stores_to_get = [];
                _this.markers.eachLayer(function (layer) {
                    if (_this.storemap.getBounds().contains(layer.getLatLng())) {
                        current_marker = {};
                        current_marker.id = layer.options.store_id;
                        current_marker.fetched = false;
                        _this.markersArray.push(current_marker);
                    }
                });
                _this.markersArray.forEach(function (store){
                    if (store.fetched === false) {
                        stores_to_get.push(store.id);
                    }
                });
                axios.post('/api/getmultiplestores/', {stores: stores_to_get})
                    .then(response => {
                        response.data.map(function (value, index) {
                            if (typeof _this.stores[value.id] !== 'object') {
                                Vue.set(_this.stores, value.id, value)
                                _this.stores[value.id].in_view = true;
                            }
                        });
                    })
                    .catch(error => {
                        console.log(error)
                    });

                setTimeout(() => {
                    _this.updateInView();
                }, 400);


            _this.updateInView();
        },
        listingClicked(store_id, lat, lng) {
            console.log(store_id + ' - ' + lat + ' - ' + lng);
            this.storemap.flyTo([lat, lng]);
            this.isActive = store_id;
            this.storemap.setView([lat, lng], 20);
            this.marker[store_id].openPopup();
        },
        markerClicked(marker_id) {
            let _this = this;
            if (typeof _this.stores[marker_id.target.options.store_id] === 'object') {
                _this.activeStore = _this.stores[marker_id.target.options.store_id];
            } else {
                this.getSingleStore(marker_id.target.options.store_id);
            }
            setTimeout(() => {
                if (this.activeStore.photos.length > 0) {
                    let slide_markup = '';
                    let popupContainer = _this.$refs.popupContainer;
                    this.marker[marker_id.target.options.loop_id].bindPopup(popupContainer,
                        {closeButton: false}
                    )
                    _this.listingSlides();
                    _this.marker[marker_id.target.options.loop_id].openPopup();
                    _this.$refs.popupContainer.style.display = 'block';
                } else {
                    this.marker[marker_id.target.options.loop_id].bindPopup('<div class="map-popup-wrap"><div class="map-popup"><div class="infoBox-close"><i class="fa fa-times"></i></div><div class="map-popup-category">' + this.activeStore.store_type + '</div><span class="listing-img-content fl-wrap"><img src="' + this.activeStore.main_img + '" alt=""></a> <div class="listing-content fl-wrap"><div class="card-popup-raining map-card-rainting" data-staRrating="' + this.activeStore.google_rating + '"><span class="map-popup-reviews-count">( ' + (this.activeStore.ratingCount == 1 ? this.activeStore.ratingCount + ' review' : this.activeStore.ratingCount + ' reviews') + ')</span></div><div class="listing-title fl-wrap"><h4><a href=/' + this.activeStore.store_url_slug + '>' + this.activeStore.store_name + '</h4><span class="map-popup-location-info"><i class="fa fa-map-marker"></i>' + this.activeStore.store_address + '</span><span class="map-popup-location-phone"><i class="fa fa-phone"></i>' + this.activeStore.store_phone + '</span></div></div></div></div>',
                    //this.marker[marker_id.target.options.loop_id].bindPopup('<div class="map-popup-wrap"><div class="map-popup"><div class="infoBox-close"><i class="fa fa-times"></i></div><div class="map-popup-category">' + this.activeStore.store_type + '</div><span class="listing-img-content fl-wrap"><img src="' + this.activeStore.main_img + '" alt=""></a> <div class="listing-content fl-wrap"><div class="card-popup-raining map-card-rainting" data-staRrating="' + this.activeStore.google_rating + '"><span class="map-popup-reviews-count">( ' + this.activeStore.google_rating_count + ' reviews )</span></div><div class="listing-title fl-wrap"><h4><a href=/' + this.activeStore.store_url_slug + '>' + this.activeStore.store_name + '</h4><span class="map-popup-location-info"><i class="fa fa-map-marker"></i>' + this.activeStore.store_address + '</span><span class="map-popup-location-phone"><i class="fa fa-phone"></i>' + this.activeStore.store_phone + '</span></div></div></div></div>',
                        {closeButton: false}
                    )
                    _this.marker[marker_id.target.options.loop_id].openPopup();
                }
            }, 200);
        },
        directionClick(e, direction) {
            e.preventDefault();
            if (typeof (this.isActive) == "undefined") {
                let store_index = direction === 'next' ? 0 : (this.marker.length - 1);
                this.listingClicked(store_index, this.marker[store_index]._latlng.lat, this.marker[store_index]._latlng.lng);
            } else {
                let new_index = '';
                if(direction === 'next') {
                    if (this.isActive + 1 < this.marker.length) {
                        new_index = this.isActive + 1;
                    } else {
                        new_index = 0;
                    }
                } else {
                    if (this.isActive === 0) {
                        console.log('this is running')
                        new_index = (this.marker.length - 1);
                    } else {
                        new_index = this.isActive - 1;
                    }
                }
                this.listingClicked(new_index, this.marker[new_index]._latlng.lat, this.marker[new_index]._latlng.lng);
            }
        },
        sidebarListingClicked(store) {
            this.marker[store.id].openPopup();
            this.listingClicked(store.id, store.lat, store.lng);
        },
        updateZoom(){
            this.zoomLevel = this.storemap.getZoom();
        },
        loadStoresInView(bounds) {
            this.updateZoom();
            let _this = this;
            if (_this.stores.length <= 6071) {
                this.zoomCoords.neLat = bounds.target.getBounds()._northEast.lat;
                this.zoomCoords.neLng = bounds.target.getBounds()._northEast.lng;
                this.zoomCoords.swLat = bounds.target.getBounds()._southWest.lat;
                this.zoomCoords.swLng = bounds.target.getBounds()._southWest.lng;

                axios.post('/api/mapzoom/', {coords: this.zoomCoords, loaded_ids: this.loadedIds})
                    .then(response => {

                        //this.stores = {...this.stores, ...response.data };
                        //this.stores = response.data;
                        response.data.map(function (value, index) {
                            if (_this.loadedIds.indexOf(value.id) === -1) {
                                _this.stores.push(value);
                            }
                        });
                        //this.loadMarkers();
                        //this.resizeAndReload();
                    })
                    .catch(error => {
                        console.log(error)
                    });
            }
        },
        updateInView() {
            let _this = this;
            setTimeout(() => {
                Object.keys(_this.stores).forEach(function (value){
                    if (_this.markersArray.includes(_this.stores[value].id)) {
                        _this.stores[value].in_view = true;
                    } else {
                        //console.log('this is the problem area with side listings disappearing on marker click');
                        _this.stores[value].in_view = false;
                    }
                });
            }, 400);
        },
        initSidebar() {
            let _this = this;
            if (window.innerWidth >= 1030) {

            }
        },

        resizeAndReload() {
            this.sideHeight = this.$refs.sidebarListing.clientHeight;

            if (this.winWidth > 768) {
                console.log('gtrater');
                $('.sidebar-listing').height(this.sideHeight);
            }
            this.mapSlyelement.obj.reload();
            console.log('resizing');
        },
        pluck(array, key) {
            return array.map(function(obj) {
                return obj[key];
            });
        },
        isMobile() {
            if(this.winWidth < 1030) {
                return true
            } else {
                return false
            }
        },
        listingSlides() {
            let _this = this;
            //console.log('first run is '+_this.popupSliderFirstRun)
            setTimeout(() => {
                if (_this.popupSliderFirstRun === false) {
                    _this.splide_slider = new Splide( _this.$refs.popupSlider, {
                        type     : 'loop',
                        height   : '10rem',
                        focus    : 'center',
                        autoWidth: true,
                    } );
                    _this.splide_slider.mount();
                    _this.popupSliderFirstRun = true;
                } else {
                    _this.splide_slider.refresh();
                }
            }, 400);
        },
        getTodayHours (hours){
            switch(this.dates.getDay()) {
                case 0:
                    this.dayText = 'Sunday';
                    break;
                case 1:
                    this.dayText = 'Monday';
                    break;
                case 2:
                    this.dayText = 'Tuesday';
                    break;
                case 3:
                    this.dayText = 'Wednesday';
                    break;
                case 4:
                    this.dayText = 'Thursday';
                    break;
                case 5:
                    this.dayText = 'Friday';
                    break;
                case 6:
                    this.dayText = 'Saturday';
                    break;
                default:
                // code block
            }
            if (hours) {
                if (typeof hours == 'string') {
                    hours = hours.split(',');
                }
                for (var i = 0; i < hours.length; i++) {
                    if (hours[i].includes(this.dayText)) {
                        var today_hours = hours[i].replace('["', '' );
                        return today_hours;
                    }
                }
            }
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MapView.vue